import React from 'react';

const ConverteData = (p) => <span>{!p.children || p.children === "-" ? " - " : new Date(p.children).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}</span>

export default ConverteData;